import React, { useRef } from "react";
import axios from "axios";
import { Typography } from "@material-tailwind/react";
import { Breadcrumbs } from "@material-tailwind/react";
import { Link, useNavigate } from "react-router-dom";
import { IoIosEyeOff } from "react-icons/io";
import { IoIosLaptop } from "react-icons/io";
import {
  usePagination,
  useMemo,
} from "@mui/material/usePagination/usePagination";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Avatar,
} from "@material-tailwind/react";
import { useState, useEffect } from "react";
import Loading from "../../../COMPONENTS/Loading/Loading";
import { IoAddSharp } from "react-icons/io5";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { FiEdit } from "react-icons/fi";
import { RxDotsVertical } from "react-icons/rx";
import {
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  IconButton,
  Tooltip,
} from "@material-tailwind/react";
import { IoIosEye } from "react-icons/io";
import SidebarTop from "../../SidebarTop";
import { ToastContainer, toast } from "react-toastify";
import { GiMoneyStack } from "react-icons/gi";
import { CiCalendarDate } from "react-icons/ci";
import { useTranslation } from "react-i18next";
import Create from "../../../../Payment/Create";



function VoirHebergement() {
  const { t } = useTranslation();
  const TABLE_HEAD = [
    "Action",
    t("Statut"),
    t("Nom de la salle"),
    t("chambres"),
    t("Type de lit"),
    t("Périmètre"),
    t("État"),
  ];

  localStorage.setItem(
    "url",
    JSON.stringify("/Dashboard/Publications/Hebergement/Voir_des_hebergements")
  );

  // États pour gérer le formulaire et le popup
  const [showPopup, setShowPopup] = useState(false);

  const [records, setRecords] = useState([]);

  const [data, setData] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("data");
    const initialValue = saved !== null ? JSON.parse(saved) : null;
    return initialValue;
  });
  const dateexpired = new Date();
  const dateexpired1 = dateexpired.toISOString().split("T")[0];
  // console.log(dateexpired1);
  const [open, setOpen] = React.useState(false);
  var [listUpDateHeber, setlistUpDateHebeL] = React.useState([]);
  //const [identifiantHeber, setIdentifiantHeber] = React.useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [pricePub, setPricePub] = useState(null);

  const [priceD, setPriceD] = useState(null);
  const [identifiant, setIdentifiant] = useState(null);
  const [options, setOptions] = useState(null);
  const [curr,setCurr] = useState();
  

  // Initialisez seulement les champs nécessaires
  const initialFormData = JSON.parse(localStorage.getItem("formData")) || {
    date_debut: "",
    date_fin: "",
    identifiant: listUpDateHeber?.id_announce || identifiant,
  };

  if (localStorage.getItem("message")) {
    toast.success("Bien ajouter avec succes");
    localStorage.removeItem("message");
  }
  const [formData, setFormData] = useState(initialFormData);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData, [name]: value };
      //console.log("Updated formData in handleInputChange:", updatedFormData);
      localStorage.setItem("formData", JSON.stringify(updatedFormData));
      return updatedFormData;
    });
  };

  const handleClickOpen = (id) => {
    setOpen(true);
    async function listOfReafficherHerb() {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/hebergement/list/update/pub`,
          { id: id }
        );
        //console.log(res)
        setlistUpDateHebeL(res.data.data);
        setIdentifiant(res.data.data.id_announce);
        setFormData((prevFormData) => ({
          ...prevFormData,
          identifiant: res.data.data.id_announce,
        }));
        localStorage.setItem(
          "formData",
          JSON.stringify({
            ...formData,
            identifiant: res.data.data.id_announce,
          })
        );
      } catch (err) {
        console.log(err);
      }
    }
    listOfReafficherHerb();
  };

  const handleClose = () => {
    setOpen(false);
  };

  //Récuppérer le prix de publication
  const getPricePub = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/prix/pub/hebergement`
      );
      //console.log(res.data.data.Prices);
      setPricePub(res.data.data.Prices);
      localStorage.setItem("pricePub", res.data.data.Prices);
    } catch (err) {
      console.log(err);
    }
  };

  const getPriceDollar = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/prix/dollar`
      );
      //console.log(res.data.data.value_to_xof);
      setPriceD(res.data.data.value_to_xof);
    } catch (err) {
      console.log(err);
    }
  };

  ///////////////////// début pagination ////////////////////
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(3); //le nombre d'éléments à afficher par page
  // Calcul du nombre total de pages
  const totalPages = Math.ceil(records.length / itemsPerPage);

  // Récupération des enregistrements pour la page actuelle
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = records.slice(startIndex, endIndex);

  // Fonctions pour naviguer entre les pages
  const nextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  ///////////////////// fin pagination ////////////////////

  const changeStatut = (id) => {
    async function ChangeStatutHerb() {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/hebergement/change/statut`,
          { id: id }
        );
        window.location.reload();
        if (res.data.status === 201) {
          toast.success(res.data.message);
          //console.log(res);
        } else {
          toast.error(res.data.message);
          console.log(res);
        }
      } catch (err) {
        console.log(err);
      }
    }
    ChangeStatutHerb();

    //  .then(res => {
    //   window.location.reload();
    //   if (res.data.status === 201) {
    //     toast.success(res.data.message);
    //     //console.log(res);
    //   } else {
    //       toast.error(res.data.message);
    //       console.log(res);
    //   }
    // })
    //  .catch(err =>
    //   {
    //     toast.error("Erreur Merci de ressayer");
    //    console.log(err)
    //   })
  };

  const submitForm = async (provider,paymentId,currencyId) => {
    //event.preventDefault();
    // Récupérer les données du formulaire depuis le localStorage ou l'état
    const pricePubFromStorage = localStorage.getItem("pricePub");
    const currentFormData =
      JSON.parse(localStorage.getItem("formData")) || formData;

   
    const fd = new FormData();
    const identifiantValue =
      currentFormData.identifiant || identifiant || listUpDateHeber.id_announce;
    const date_debut = currentFormData.date_debut || listUpDateHeber.date_debut;
    const date_fin = currentFormData.date_fin || listUpDateHeber.date_fin;

    fd.append("identifiant", identifiantValue);
    fd.append("date_debut", date_debut);
    fd.append("date_fin", date_fin);
    fd.append('userId',data.userId)
    if (date_debut && pricePubFromStorage && date_fin) {
      const days = Math.ceil(
        (new Date(date_fin) - new Date(date_debut)) / (1000 * 60 * 60 * 24)
      );
      const montant = parseFloat(pricePubFromStorage) * days;
      fd.append("montant", montant);
      //console.log("Calculated montant:", montant);
    } else {
      toast.error("Veuillez remplir tous les champs");
      return;
    }

    //setLoading(true);
    try {
      //const res = await Tourisme.submitFormPopUp(fd);
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/hebergement/send/update/popup/hebergement`,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res.data.status === 201) {
                setOpen(false);
                setShowPopup(false);
                if(provider !== null && paymentId !== null && currencyId !== null ){
                        const formD = {
                                userId:data.azId,
                                montant:totalPaid,
                                provider: provider,
                                payement_id:paymentId ,
                                currency:currencyId,
                                annonce_number: identifiantValue,
                                description:"Plonlongement de la publication  d'un hebergement",
                            }
                        axios.post(`${process.env.REACT_APP_BASE_URL}/api/store/rechargement-paiememnt`,formD)
                            .then((res)=>{
                            if(res.data.status === 200){
                            //toast.success(res.data.message);
                            //console.log("enregistrement reussie")
                            }
                            }).catch((err)=>{
                            console.log("Erreur lors de l'appel a l'API ",err)
                            })
                  }
        toast.success(res.data.message);
        setRecords(res.data.data);
        localStorage.removeItem("pricePub");
        localStorage.removeItem("formData");
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
        console.log("Erreur ",err)
      toast.error("Erreur merci de réessayer !");
    } finally {
      setLoading(false);
    }
  };

  // Fonction de gestion de la soumission du formulaire
  const handleSubmit = (event) => {
    event.preventDefault();
    if(totalPaid === 0)
    {
      submitForm();
      return;
    }
    // Afficher le popup de paiement
    setShowPopup(true);
  };

  useEffect(() => {
    if (!data) {
      navigate("/Connexion");
    }

    // Appel API pour récupérer la monnaie
      axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/get/info/website`)
      .then((res) => {
      if (res.data.status === 200 ) {
          setCurr(res.data.currency);
          localStorage.setItem('id_currency', res.data.currency.id_currency);
      } else {
          console.warn("Réponse inattendue de l'API :", res.data);
      }
      })
      .catch((err) => {
      console.error("Erreur lors de l'appel à l'API :", err);
      });

    getPriceDollar();
    getPricePub();
    async function listHerb() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/hebergement/list/${data.userId}`
        );

        // console.log("L'utilisateur connecter est ",data.userId)
        setRecords(response.data.data);
        const initialFormData = {
          identifiant: listUpDateHeber?.id_announce || identifiant,
          date_debut: listUpDateHeber?.date_debut || "",
          date_fin: listUpDateHeber?.date_fin || "",
        };
        setFormData(initialFormData);
        localStorage.setItem("formData", JSON.stringify(initialFormData));
        // console.log('Fetched records:', response.data.data);
      } catch (err) {
        console.log(err);
      }
    }
    listHerb();

    const timer = setTimeout(() => {
      // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
      setLoading(false);
    }, 2000); // 5000 millisecondes = 5 secondes

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    return () => clearTimeout(timer);
  }, [data, pricePub]);

  const [totalPaid, setTotalPaid] = useState(0);
  
   useEffect(() => {
                const currentDate = new Date();
                const formattedCurrentDate = currentDate.toISOString().split("T")[0];
                const today = new Date(formattedCurrentDate);
              
                const startDate = new Date(formData.date_debut || listUpDateHeber.date_debut);
                const endDate = new Date(formData.date_fin || listUpDateHeber.date_fin);
                //console.log("date de fin ",endDate)
              
                const oneDayMs = 1000 * 60 * 60 * 24;
              
                let days;
                if (startDate < today || startDate === "") {
                  days = Math.ceil((endDate - today) / oneDayMs);
                } else {
                  days = Math.ceil((endDate - startDate) / oneDayMs);
                }
              
                days = days > 0 ? days : 0;
              
                const total = parseFloat(pricePub) * days;
                
                setTotalPaid(total);
    }, [formData,listUpDateHeber, pricePub]);

   useEffect(() => {
           if (curr) {
       
             setOptions({
               id_currency: curr.id_currency,
               success_url:window.location.origin,
               cancel_url: window.location.href,
               amount:totalPaid,
               customer: {
                 id: data.azId,
                 first_name: data.userLastname ?? '',
                 last_name: data.userName ?? '',
                 email: data.userMail,
                 phone: data.userTel,
                 code_country: 'BJ'
               },
               seller_number: data.azId
             });
           }
     }, [curr,totalPaid]);  

 
  
  return (
    <div className="flex flex-row bg-[#eeee]">
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          <div className="w-screen h-screen barre_scroll">
            {/* sidebar top  */}
            <SidebarTop />
            <div>
              <ToastContainer />
            </div>
            {/* navbar top gris*/}
            <div className="bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]">
              <Breadcrumbs>
                <Link to="" className="opacity-60 md:text-base s:text-xs">
                  {t("Mes publications")}
                </Link>
                <Link
                  to="/Dashboard/Publications/Hebergement/Voir_des_hebergements"
                  className="opacity-60 md:text-base s:text-xs"
                >
                  {t("Hebergements")}
                </Link>
                <Link to="" className="md:text-base s:text-xs">
                  {t("Voir")}
                </Link>
              </Breadcrumbs>
            </div>

            {/* boutton ajouter une residence */}
            <div className="p-6  w-[230px]">
              <Link to="/Dashboard/Publications/Hebergement/Ajouter_des_hebergements">
                <button className="flex flex-row items-center justify-center h-10  space-x-2 bg-[#FCCA46] text-white md:text-base s:text-sm md:w-[230px] s:w-[190px] transform active:scale-75 transition-transform">
                  <IoAddSharp />
                  <p>{t("Ajouter un hebergement")}</p>
                </button>
              </Link>
            </div>
            {/* container formulaire */}
            <div className="flex justify-center md:p-10 s:p-4">
              <Card className="h-full w-full border-t-8 border-[#fe7f2d]">
                <CardHeader
                  floated={false}
                  shadow={false}
                  className="rounded-none"
                >
                  <Typography
                    className="font-semibold md:text-xl s:text-lg"
                    color="blue-gray"
                  >
                    {t("Liste des chambres publiées")}
                  </Typography>
                </CardHeader>
                <CardBody className="px-0 overflow-scroll">
                  <table className="w-full mt-4 overflow-scroll text-left table-auto min-w-max">
                    <thead>
                      <tr>
                        {TABLE_HEAD.map((head, index) => (
                          <th
                            key={head}
                            className="p-4 transition-colors cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 hover:bg-blue-gray-50"
                          >
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="flex items-center justify-between gap-2 font-normal leading-none opacity-70"
                            >
                              {head}{" "}
                              {index !== TABLE_HEAD.length - 1 && (
                                <ChevronUpDownIcon
                                  strokeWidth={2}
                                  className="w-4 h-4"
                                />
                              )}
                            </Typography>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    {records.length === 0 && (
                      <tbody>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="flex items-center font-normal"
                        >
                          {t("Pas de donnees")}
                        </Typography>
                      </tbody>
                    )}
                    {records.length > 0 && (
                      <tbody>
                        {currentItems.map((list, index) => {
                          const isLast = index === records.length - 1;
                          const classes = isLast
                            ? "p-4"
                            : "p-4 border-b border-blue-gray-50";

                          return (
                            <tr key={index} className="hover:bg-slate-100">
                              <td className={classes}>
                                <Tooltip content="Action sur la publication">
                                  <IconButton variant="text">
                                    <Menu>
                                      <MenuHandler>
                                        <IconButton>
                                          <RxDotsVertical />
                                        </IconButton>
                                      </MenuHandler>
                                      <MenuList className="flex flex-col gap-2">
                                        {/* modifier */}
                                        <Link
                                          to="/Dashboard/Publications/Hebergement/Voir_des_hebergements/Modifier"
                                          state={list.id_announce}
                                        >
                                          <MenuItem className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100">
                                            <FiEdit className="text-lg" />
                                            <div className="flex flex-col gap-1">
                                              <Typography
                                                variant="small"
                                                color="gray"
                                                className="font-semibold"
                                              >
                                                {t("Modifier")}
                                              </Typography>
                                            </div>
                                          </MenuItem>
                                        </Link>
                                        {/* Voir */}
                                        <Link
                                          to="/Dashboard/Publications/Hebergement/Voir_des_hebergements/Voir_Plus"
                                          state={list.id_announce}
                                        >
                                          <MenuItem className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100">
                                            <IoIosEye className="text-lg" />
                                            <div className="flex flex-col gap-1">
                                              <Typography
                                                variant="small"
                                                color="gray"
                                                className="font-semibold"
                                              >
                                                {t("Voir")}
                                              </Typography>
                                            </div>
                                          </MenuItem>
                                        </Link>
                                        {/* Desactiver / Activer */}

                                        {list.status === "enabled" && (
                                          <MenuItem
                                            onClick={() =>
                                              changeStatut(list.id_announce)
                                            }
                                            className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100"
                                          >
                                            <IoIosEyeOff className="text-lg" />
                                            <div className="flex flex-col gap-1">
                                              <Typography
                                                variant="small"
                                                color="gray"
                                                className="font-semibold"
                                              >
                                                {t("Désactiver")}
                                              </Typography>
                                            </div>
                                          </MenuItem>
                                        )}
                                        {list.status === "disabled" && (
                                          <MenuItem
                                            onClick={() =>
                                              changeStatut(list.id_announce)
                                            }
                                            className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100"
                                          >
                                            <IoIosEye className="text-lg" />
                                            <div className="flex flex-col gap-1">
                                              <Typography
                                                variant="small"
                                                color="gray"
                                                className="font-semibold"
                                              >
                                                {t("Activer")}
                                              </Typography>
                                            </div>
                                          </MenuItem>
                                        )}
                                        {dateexpired1 > list.date_fin ? (
                                          <MenuItem
                                            onClick={() =>
                                              handleClickOpen(list.id_announce)
                                            }
                                            className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100"
                                          >
                                            <IoIosLaptop className="text-lg" />
                                            <div className="flex flex-col gap-1">
                                              <Typography
                                                variant="small"
                                                color="gray"
                                                className="font-semibold"
                                              >
                                                {t("Reafficher")}
                                              </Typography>
                                            </div>
                                          </MenuItem>
                                        ) : (
                                          ""
                                        )}
                                      </MenuList>
                                    </Menu>
                                  </IconButton>
                                </Tooltip>
                              </td>
                              <td className={classes}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal"
                                >
                                  {list.status === "enabled" && t("Actif")}
                                  {list.status === "disabled" && t("Inactif")}
                                </Typography>
                              </td>
                              <td className={classes}>
                                <div className="flex items-center space-x-2 ">
                                  <Avatar
                                    src={`data:image/png;base64,${list[0]}`}
                                    alt={list.title_announce}
                                    className="w-[180px] h-[100px]"
                                  />
                                  <div className="flex flex-col">
                                    <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal"
                                    >
                                      {list.title_announce}
                                    </Typography>
                                    <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal opacity-70"
                                    >
                                      {list.price_announce} XOF / Nuitée
                                    </Typography>
                                  </div>
                                </div>
                              </td>
                              <td className={classes}>
                                <div className="flex flex-col">
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {list.realstate_number_pieces} chambre (s)
                                  </Typography>
                                </div>
                              </td>
                              <td className={classes}>
                                <div className="flex flex-col">
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {list.realstate_bedtype}
                                  </Typography>
                                </div>
                              </td>
                              <td className={classes}>
                                <div className="w-max">
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {list.realstate_size} m
                                  </Typography>
                                </div>
                              </td>
                              <td className={classes}>
                                <div className="w-max">
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {list.status}
                                  </Typography>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    )}
                  </table>
                </CardBody>
                <CardFooter className="flex items-center justify-between p-4 border-t border-blue-gray-50">
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal"
                  >
                    Page {currentPage} of {totalPages}
                  </Typography>
                  <div className="flex gap-2">
                    <Button
                      variant="outlined"
                      onClick={prevPage}
                      size="sm"
                      disabled={currentPage === 1}
                    >
                      {t("Previous")}
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={nextPage}
                      size="sm"
                      disabled={currentPage === totalPages}
                    >
                      {t("Next")}
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            </div>
          </div>
        </>
      )}

      {
        open && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-400">
                <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                    {/* Bouton de fermeture à l'intérieur du modal */}
                    <button
                    onClick={() => setOpen(false)}
                    className="absolute top-3 right-3 text-red-500 text-2xl"
                >
                    &times;
                </button>
                    <form onSubmit={handleSubmit} className='flex flex-col items-center w-full max-w-2xl mx-auto space-y-6'>

                      <div className='flex flex-col w-full space-y-4 bg-white border-b-8 rounded-md shadow s:p-6 xs:p-10'>
                          <h3 className='text-xl text-[#fe7f2d] text-center'>Modification</h3>
                          {/* date debut */}
                          <input hidden id="identifiant" value={identifiant || formData.identifiant} onChange={handleInputChange} type='number' name='identifiant' className='w-full h-10 rounded' />
                          <div className='flex flex-col space-y-3'>
                              <div className='flex flex-row items-center space-x-2'>
                                  <CiCalendarDate className='text-[#fe7f2d]' />
                                  <label>Date de debut affichage</label>
                              </div>
                              <input id="date_debut" 
                                    value={formData.date_debut || listUpDateHeber?.date_debut} 
                                    name='date_debut' onChange={handleInputChange} 
                                    type='date' className='w-full h-10 rounded' required />
                          </div>

                          {/* date fin */}
                          <div className='flex flex-col space-y-3'>
                              <div className='flex flex-row items-center space-x-2'>
                                  <CiCalendarDate className='text-[#fe7f2d]' />
                                  <label>Date de fin affichage</label>
                              </div>
                              <input id="date_fin" 
                                    value={formData.date_fin || listUpDateHeber?.date_fin} 
                                    name='date_fin' onChange={handleInputChange} 
                                    type='date' className='w-full h-10 rounded' required />
                          </div>

                          {totalPaid !== 0 ? (
                              <div className='flex flex-col items-center mx-2 space-y-3 text-center'>
                                  <div className='flex flex-row items-center space-x-2 bg-[#1F2937] h-10 rounded'>
                                      <GiMoneyStack className='text-xl text-white' />
                                      <label className='font-bold text-white'>
                                          Montant total: {totalPaid} F CFA
                                      </label>                                
                                  </div>
                              </div>
                          ) : ""}
                      </div>

                      {totalPaid !== 0 ? (
                          <button className='bg-[#FCCA46] w-[250px] h-10 rounded text-white'>
                              Procéder au paiement
                          </button>
                      ) : (
                          <button className='bg-[#FCCA46] w-[150px] h-10 rounded text-white'>
                              Reafficher
                          </button>
                      )}
                    </form>
                      
                </div>
        </div>
        )
      }

      {showPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-400">
              <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                  {/* Bouton de fermeture à l'intérieur du modal */}
                  <button
                  onClick={() => setShowPopup(false)}
                  className="absolute top-3 right-3 text-red-500 text-2xl"
              >
                  &times;
              </button>
                  <Create item="Rechargement de la carte AZ"  options={options} onSuccess={submitForm} ></Create>
              </div>
            </div>
      )}
    </div>
  );
}

export default VoirHebergement;
